
if (!customElements.get('cta-bundle-select')) {
    class CTABundleSelect extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.init();
    }

    init() {
      const buttons = this.querySelectorAll('button[data-bundle-items]');
      if (!buttons.length) return;

      buttons.forEach((button) => {
        button.addEventListener('click', (event) => this.handleClick(event));
      });
    }

    handleClick(event) {
      let variantIds = JSON.parse(event.currentTarget.getAttribute('data-bundle-items') || '[]');
      const form = document.querySelectorAll('.vbb-set__details__item');
      const removeButtons = document.querySelectorAll('.vbb-set__details__item--button__remove');

      // Remove optional items before adding new ones
      removeButtons.forEach((btn) => btn.click());

      let tempVariants = [...variantIds];

      form.forEach((item) => {
        for (let i = 0; i < tempVariants.length; i++) {
          const id = tempVariants[i];
          const matchingElement = item.querySelector(`[data-active-variant-id="${id}"]`) ||
                                  item.querySelector(`[data-variant-id="${id}"]`);

          if (matchingElement) {
            console.log("Found match for variant ID:", id, matchingElement);
            tempVariants.splice(i, 1); // Remove found ID from array
            matchingElement.click(); // Simulate click on the matching element
            break; // Move to the next form item
          }
        }
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }

  customElements.define('cta-bundle-select', CTABundleSelect);
}
